<template>
    <div>
        <form-container :headerText="title" :width="650" :action="action"
                        :button-ok-second="action==='addPlayer'?'Speichern u. Foto hochladen':''"
                        :button-ok-color="action==='addPlayer'?'grey darken-1':'primary'"
                        :valid-actions="['addPlayer', 'editNew', 'edit']" @save="save" @saveSecond="saveSecond">
            <v-container v-if="show" class="px-6" >
                <v-row>
                    <v-col v-for="(field, i) in fieldList" :key="i"
                            :cols="field.cols ? $vuetify.breakpoint.xsOnly ? 12 : field.cols : 12"
                            class="px-4 py-0">
                        <div v-if="field.childOf === ''">
                            <v-text-field v-if="field.type==='date' && !field.optional"
                                          type="date"
                                          v-model="dataObject[field.id]"
                                          :label="field.app" :rules="getRules(field)">
                            </v-text-field>
                            <input-date-optional v-else-if="field.type==='date' && field.optional"
                                                 :field="field" :data-object="dataObject"
                                                 @dateError="setDateError">
                            </input-date-optional>
                            <v-select v-else-if="field.type==='select'"
                                      :items="field.values"
                                      :label="field.app" :rules="getRules(field)"
                                      v-model="dataObject[field.id]">
                            </v-select>
                            <v-text-field v-else v-model="dataObject[field.id]"
                                          :label="field.app" :rules="getRules(field)">
                            </v-text-field>
                        </div>
                        <div v-else>
                            <v-text-field v-if="field.type==='date' && !field.optional"
                                          type="date"
                                          v-model="dataObject[field.childOf][field.id]"
                                          :label="field.app" :rules="getRules(field)">
                            </v-text-field>
                            <v-select v-else-if="field.type==='select'"
                                      :items="field.values"
                                      :label="field.app" :rules="getRules(field)"
                                      v-model="dataObject[field.childOf][field.id]">
                            </v-select>
                            <v-text-field v-else v-model="dataObject[field.childOf][field.id]"
                                          :label="field.app" :rules="getRules(field)">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12" class="px-4"><error-msg :error="errorMsg" v-if="errorMsg"></error-msg></v-col>
                </v-row>
                <div class="warning--text" v-if="dataObject.private.nationalitaet==='andere'">
                    Du hast 'andere' als Nationalität gewählt. Bitte schreibe das Land in die Bemerkung damit wir den passenden Code aufsetzen können!
                </div>
                <v-alert v-model="birthdayEditWarning" text color="warning" icon="mdi-information">
                    ACHTUNG: du hast das Geburtsdatum geändert. Das kann Auswirkungen auf die Passlaufzeit und die
                    Gültigkeit von Attesten haben, die nicht automatisch geändert werden!
                </v-alert>
            </v-container>
        </form-container>
    </div>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import {FormRules} from "../../../services/formRules";
    import InputDateOptional from "../../../components/form/inputDateOptional";
    import {SpielerAction} from "../../../services/data/spielerAction/spielerAction";
    import SPIELER_MEMBERSHIP_HANDLER from "../../../services/data/spieler/spielerMembershipHandler";
    import SPIELER_CHANGE_HANDLER from "@/services/data/spieler/spielerChangeHandler";
    import TimeStamp from "../../../services/timeStamp";
    import ErrorMsg from "../../../components/elements/errorMsg";

    export default {
        components: {
            ErrorMsg,
            InputDateOptional, FormContainer},
        name: "spieler-new-edit",
        props: ['dataObject', 'action', 'currentData', 'verein', 'lv'],
        computed: {
            title(){ return this.action === 'addPlayer' ? 'Neues Mitglied anlegen' : 'Daten ändern' },
        },
        data: () => ({
            fieldList: null,
            rules: null,
            dateError: false,
            actionObject: null,
            privateData: null,
            show: false,
            errorMsg: '',
            dataSnapshot: null,
            birthdayEditWarning: false,
            geburtsdatumOriginal: ''
        }),
        created(){
            this.setDataObjectForForm();
            this.dataObject.setEmptyData();
            this.rules = new FormRules();
            //this.setTestData();
        },
        activated(){
            console.log ("activated" );
        },
        methods: {
            /*setTestData(){
                if ( !this.dataObject.id ) {
                    this.dataObject.private.geburtsdatum = '1998-07-01'
                    this.dataObject.vorname = 'Rainer';
                    this.dataObject.nachname = 'mikulik';
                    this.dataObject.geschlecht = 'm';
                    this.dataObject.private.plz = '1100';
                    this.dataObject.private.ort = 'Wien';
                    this.dataObject.private.geburtsort = 'Wien';
                    this.dataObject.private.strasse = 'hgsf';
                    this.dataObject.dsv = '2021-03-03';
                    this.dataObject.dates.anmeldeTag = '2021-03-03';
                }
            },*/
            async saveSecond(){
                let reply = await this.save();
                if ( reply.successful ) {
                    setTimeout(()=>{let p = JSON.parse(JSON.stringify(this.$route.path));
                        let q = JSON.parse(JSON.stringify(this.$route.query));
                        //q.action = 'foto';
                        q.imgId = reply.content;
                        this.$router.push({path: p, query: q});},100);
                }
            },
            async save(){
                    this.dataObject.trimStrings();
                // check
                    if ( this.dateError ) { console.log ("", ); return; }
                    if ( this.anmeldeTagInvalid() ) { this.errorMsg = 'Der Anmeldetag muss in diesem Sportjahr ' +
                        'oder am ersten Tag des nächsten Sportjahres (1.7.) liegen!'; return; }
                // fill action object and cancel if no changes
                    let replyAction = {successful: true};
                    this.$store.state.local.loader = true;
                // cancel if duplicate
                    let verificationResult = await this.verifyAndHandleDuplicates();
                    if ( !verificationResult ) {
                        this.$store.state.local.loader = false;
                        return;
                    }
                // process
                    if ( this.action !== 'addPlayer' ) {
                        this.actionObject = new SpielerAction(this.dataObject, this.action, this.lv.id, this.verein.id);
                        this.fillActionObject();
                    // cancel if no changes
                        if ( this.actionObject.changes.length === 0 ) {
                            this.$emit('actionSnack', {text: 'Du hast keine Daten geändert!', color: 'error'});
                            this.$store.state.local.loader = false;
                            window.history.back();
                            return;
                        }
                    // send action
                        if ( this.action === 'edit' ) {
                            this.actionObject.setTimeStamp();
                            this.actionObject.setEditPending();
                            this.actionObject.autoConfirmDuplicateAndContentChanges();
                            replyAction = await this.actionObject.saveNew('document');
                        }
                    }
                // send
                    this.dataObject.formatData();
                    this.dataObject.local.documentUpdates.letzteAenderung = TimeStamp.getGMTTimestamp();
                    this.dataObject.setTechnicalDataForNewSpieler(this.lv, this.verein.id, null);
                    this.dataObject.local.documentUpdates.search = this.dataObject.search;
                    //this.dataObject.setSearchData();
                    let reply;
                    if ( !this.dataObject.id ) {
                        reply = await this.dataObject.saveNew('document');
                    } else {
                        if ( this.dataObject.local.documentUpdates.vorname || this.dataObject.local.documentUpdates.nachname ) {
                            this.dataObject.local.documentUpdates = SPIELER_CHANGE_HANDLER.addPassPrintParameterToDbObject(
                                this.dataObject.local.documentUpdates, true, false)
                        }
                        reply = await this.dataObject.updateWithTransaction('spieler_' + this.action, false);
                    }
                    if ( reply.successful && replyAction.successful ) {
                        this.dataObject.private.id = this.dataObject.id ? this.dataObject.id : reply.content;
                        if ( this.action === 'addPlayer' ) {
                            reply = await this.dataObject.private.saveNew('document');
                        } else {
                            reply = await this.dataObject.private.updateWithTransaction('spielerPrivate_' + this.action, false);
                        }
                        if ( reply.successful ) {
                            this.$emit('actionSnack', {text: 'Deine Änderungen wurden gespeichert!', color: 'success'});
                            this.$store.state.local.loader = false;
                            window.history.back();
                        } else {
                            // error handling
                        }
                    } else {
                        // error handling
                    }
                    return reply;
            },
            fillActionObject(){
                //let currentData = this.$store.getters.getFromAnyRealtimeListById(['vereinsspieler', 'spielerSearchResult'], this.dataObject.id);
                this.actionObject.changes = [];
                this.dataObject.local.documentUpdates = {};
                this.fieldList.forEach( (field) => {
                    if ( field.childOf === 'private' ) {
                        if ( this.dataObject[field.childOf][field.id] !== this.privateData[field.id]) {
                        // log changes in actionObject
                            this.actionObject.changes.push(
                                {   field: field.id,
                                    valueOld: this.privateData[field.id],
                                    valueNew: this.dataObject[field.childOf][field.id]});
                        // log changed fields for the update of the spieler object
                            this.dataObject.private.local.documentUpdates[field.id] = this.dataObject[field.childOf][field.id];
                        }
                    } else if ( field.childOf !== '' ) {
                        if ( this.dataObject[field.childOf][field.id] !== this.dataSnapshot[field.childOf][field.id]) {
                        // log changes in actionObject
                            this.actionObject.changes.push(
                                {   field: field.id,
                                    valueOld: this.dataSnapshot[field.childOf][field.id],
                                    valueNew: this.dataObject[field.childOf][field.id]});
                            // log changed fields for the update of the spieler object
                            let dbField = field.childOf + '.' + field.id;
                            this.dataObject.local.documentUpdates[dbField] = this.dataObject[field.childOf][field.id];
                        }
                    } else {
                        if ( this.dataObject[field.id] !== this.dataSnapshot[field.id]) {
                        // log changes in actionObject
                            this.actionObject.changes.push(
                                {field: field.id, valueOld: this.dataSnapshot[field.id],
                                    valueNew: field.id === 'nachname' ? this.dataObject[field.id].toUpperCase() :
                                                                        this.dataObject[field.id]});
                        // log changed fields for the update of the spieler object
                            this.dataObject.local.documentUpdates[field.id] = this.dataObject[field.id];
                            this.dataObject.nachnameUpdateToUpperCase(field.id);
                        }
                    }
                });
            },
            getRules(field){
                let ruleList = [];
                if ( field.optional === undefined ) {
                    if ( field.type === 'date' ) {
                        ruleList.push(this.rules.requiredDate)
                    } else if (field.id === 'plz') {
                        ruleList.push(this.rules.zipCode);
                        ruleList.push(this.rules.required);
                    } else {
                        ruleList.push(this.rules.required)
                    }
                }
                if ( field.type === 'string' ) {
                    ruleList.push(this.rules.string)
                }
                if ( field.notInFuture ) {
                    ruleList.push(this.rules.notInFuture)
                }
                return ruleList;
            },

            setDataObjectForForm (){
                this.fieldList = this.dataObject.getFieldListEdit(this.action);
                this.dataObject.setCurrentData(this.currentData);
            },
        // checks
            setDateError(dateError){
                this.dateError = dateError;
            },
            anmeldeTagInvalid(){
                console.log ("anmeldeTagInvalid", this.dataObject.dates.anmeldeTag);
                 console.log ("anmeldeTagInvalid", this.$store.state.local.sportJahr.next);
                if ( this.action !== 'addPlayer' && this.action !== 'editNew' ) { return false }
                let sportJahr = this.$store.state.local.sportJahr;
                return !((sportJahr.current.from <= this.dataObject.dates.anmeldeTag &&
                       sportJahr.current.until >= this.dataObject.dates.anmeldeTag) ||
                        sportJahr.next.from === this.dataObject.dates.anmeldeTag);
            },
        // verify and search for duplicates
            async verifyAndHandleDuplicates(){
                let searchResult = await this.verifySearchForUniqueKey();
                for ( let i = 0; i < searchResult.content.length; i++ ) {
                    if ( searchResult.content[i].id === this.dataObject.id) { searchResult.content.splice(i, 1) }
                }
                if ( searchResult.content.length === 0 ) {
                    return true;
                } else if ( searchResult.content.length > 1 ) {
                    this.errorMsg = 'Es existieren bereits mehrere Mitglieder mit diesem Namen und diesem ' +
                        'Geburtsdatum, das ist nicht zulässig! Bitte prüfe ob es sich um ein Duplikat handelt ' +
                        'oder verändere den Namen des neuen Mitglieds (verwende z.B. einen zweiten Vornamen)!';
                    return false;
                } else {
                    return this.verifyHandleDuplicate(searchResult.content[0]);
                }
            },
                async verifySearchForUniqueKey(){
                    let params = {
                        collection: 'spieler',
                        queryField: 'search.userUnique',
                        queryOperator: '==',
                        queryValue: this.dataObject.vorname + '_' + this.dataObject.nachname.toUpperCase() + '_' +
                                    this.dataObject.private.geburtsdatum,
                    };
                    return await this.$store.dispatch('getTempSnapshotList', params);
                },
                verifyHandleDuplicate(existingSpieler){
                    let currentMembership = SPIELER_MEMBERSHIP_HANDLER.getMainMembershipForToday(existingSpieler.memberships);
                    if ( currentMembership ) {
                        this.errorMsg = "Dieses Mitglied ist aktuell bereits mit Pass-Nummer '" + currentMembership.passNr +
                                        "' im Verein '" + currentMembership.lvVereinId + "' aktiv. " +
                                        "Eine Neuanlage ist nicht zulässig, bitte ändere das Mitglied stattdessen. " +
                                        "Falls es sich wirklich zufällig um eine Person mit gleichem Namen und Geburtstag handelt, " +
                                        "ergänze bitte z.B. einen zweiten Vornamen um die Person eindeutig zu machen.";
                        return false;
                    } else {
                        let lastMembership = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(existingSpieler.memberships);
                        this.errorMsg = "Ich habe ein Mitglied mit diesem Namen und Geburtsdatum gefunden, das zuletzt bis " +
                            lastMembership.until + " mit Passnummer '" + lastMembership.passNr + "' für Verein '" +
                            lastMembership.lvVereinId + "' aktiv war. " +
                            "Bitte lasse dieses alte Mitglied durch das Passreferat löschen, damit du das Mitglied neu " +
                            "anlegen kannst.";
                        return false;
                    }
                }
        },
        watch: {
            '$route.query.action'(){
                if ( this.action === 'addPlayer' || this.action === 'editNew' || this.action === 'edit' ) {
                    this.show = false;
                    this.errorMsg = '';
                    setTimeout(()=>{this.show = true;},200);
                    console.log ("WATCH SPIELER NEW EDIT", this.$route.query.action);
                    if ( this.$route.query.action === this.action ) {
                        this.setDataObjectForForm();
                    } else {
                        this.dataObject.setEmptyData();
                    }
                }
            },
            'dataObject.private.id'(){
                this.privateData = JSON.parse(JSON.stringify(this.dataObject.private));
                this.geburtsdatumOriginal = this.dataObject.private.geburtsdatum
                console.log ("!!!! privateData", this.privateData);
            },
            currentData(to){
                this.dataSnapshot = JSON.parse(JSON.stringify(to))
            },
            'dataObject.private.geburtsdatum'(to, from){
                this.birthdayEditWarning =  this.dataObject.id !=='' &&
                                            this.dataObject.search.passStatus !== 'beantragt' &&
                                            to!=='' && from!=='' &&
                                            this.geburtsdatumOriginal !== this.dataObject.private.geburtsdatum
            },
        }
    }
</script>

<style scoped>

</style>